module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portfolio-modal modal fade",
    attrs: {
      "id": "portfolioModal1",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "close-modal",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('div', {
    staticClass: "lr"
  }, [_c('div', {
    staticClass: "rl"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h2', [_vm._v("Netsix")]), _vm._v(" "), _c('p', {
    staticClass: "item-intro text-muted"
  }, [_vm._v("Main view of the app.")]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid d-block mx-auto",
    attrs: {
      "src": require("../../assets/img/screenshot-connected.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Here you can watch videos from your friends' collections.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Close")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210de21f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/PortfolioModals.vue
// module id = 111
// module chunks = 1